module.exports = __webpack_public_path__ + "img/modal-img.32c46265.png";